export const Toast = {
    show_ajax_error( data: { toast: string; error: string; } ) {
        let message = data.toast

        if ( data.error ) {
            message += `<br>${data.error}`
        }

        jQuery.toast(
            {
                position: this.get_position(),
                message,
                newestOnTop: this.get_position().includes( 'bottom' ),
                displayTime: this.get_time(),
                showProgress: 'bottom',
                compact: false,
                class: 'error',
                showIcon: 'times',
            }
        )
    },

    show_ajax_response( message: string, status: string = 'success', icon: string | boolean = false ) {
        Toast.show( message, status, icon )
    },

    show( message: string, status: string = 'success', icon: string | boolean = false ) {
        jQuery.toast(
            {
                message,
                position: this.get_position(),
                newestOnTop: this.get_position().includes( 'bottom' ),
                displayTime: this.get_time(),
                showProgress: 'bottom',
                compact: false,
                class: status,
                classProgress: ( status === '' ? 'info' : false ),
                showIcon: ( icon ? icon : ( status === 'success' ? 'checkmark' : false ) ),
            }
        )
    },

    // wichtig: return false nötig, sonst Submit Event.
    show_invalid_form(): boolean {
        console.log( 'show invalid form' )
        const message = 'Einige Angaben sind noch fehlerhaft oder unvollständig.<br> Bitte die Formularhinweise beachten und erneut versuchen.'
        Toast.show_ajax_response( message, '', 'info' )
        return false
    },

    get_position() {
        if ( gt_user_settings.toast_position === '' || gt_user_settings.toast_position === 'default' ) {
            return gt_toast.position
        }

        return gt_user_settings.toast_position
    },

    get_time(): number {
        if ( gt_user_settings.toast_time === '' || gt_user_settings.toast_time === 'default' ) {
            return Number( gt_toast.display_time )
        }

        return Number( gt_user_settings.toast_time )
    },
}
